/**
 * Invoice (فاکتور) identity completeness checks shared by the Profile and
 * Wallet pages. A user can receive an invoice only when their identity
 * information is complete, based on their person type:
 * - real (حقیقی): name, family name, national code, postal code, phone
 * - legal (حقوقی): company name, legal national ID (شناسه ملی)
 */

export type PersonType = "real" | "legal";

export interface InvoiceIdentityUser {
  person_type?: string | null;
  name?: string | null;
  family_name?: string | null;
  national_code?: string | null;
  postal_code?: string | null;
  phone?: string | null;
  company_name?: string | null;
  national_id?: string | null;
}

export function getPersonType(user: InvoiceIdentityUser | undefined | null): PersonType {
  return user?.person_type === "legal" ? "legal" : "real";
}

export function isInvoiceInfoComplete(
  user: InvoiceIdentityUser | undefined | null,
  personType: PersonType = getPersonType(user)
): boolean {
  if (!user) return false;
  if (personType === "legal") {
    return Boolean(user.company_name?.trim() && user.national_id?.trim());
  }
  return Boolean(
    user.name?.trim() &&
      user.family_name?.trim() &&
      user.national_code?.trim() &&
      user.postal_code?.trim() &&
      user.phone?.trim()
  );
}
